import { render, staticRenderFns } from "./TransactionHistory.vue?vue&type=template&id=70a7cee2&scoped=true&"
import script from "./TransactionHistory.vue?vue&type=script&lang=ts&"
export * from "./TransactionHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a7cee2",
  null
  
)

export default component.exports